import { useEffect, useState } from "react";
import api from "../../services/api";
import useWrapper from "../useWrapper";
import { stringToDate } from "../utils/useFormat";
import { calculateFees, nextBusinessDayBR } from "@entaoformouorg/formou-shared-functions";
import { isSlipOverdue, slipStatusLabel } from "./listFinancial";

const usePaymentSlip = props => {
  const { config } = useWrapper();

  const { is_trainee = false } = props;

  const [query, setquery] = useState("");
  const [load, setload] = useState();
  const [reload, setreload] = useState();
  const [paymentSlips, setpaymentSlips] = useState();
  useEffect(() => {
    if (load || query) {
      (async () => {
        try {
          setpaymentSlips();
          const _custom_payment = await api.get(`${is_trainee ? "trainee/" : ""}paymentslips${query}`, config);
          const _custom_payment_data = _custom_payment?.data?.data || _custom_payment?.data;

          setpaymentSlips({
            ...(!!_custom_payment?.data?.page
              ? {
                  pages: {
                    current: _custom_payment?.data.page,
                    total: _custom_payment?.data.lastPage,
                    results: _custom_payment?.data.total,
                    size: _custom_payment?.data.perPage,
                  },
                }
              : {}),
            data: _custom_payment_data.map(__payment => {
              const _due_date = stringToDate(__payment.due_date);
              const _due_business_date = nextBusinessDayBR(_due_date);

              let _calculated_juros = 0;
              if (isSlipOverdue(_due_business_date) && !__payment.value_paid && __payment.status !== "cancelado") {
                _calculated_juros = calculateFees({
                  value: __payment.value,
                  due_date: __payment.due_date,
                });
              }

              const _status = slipStatusLabel({
                status: __payment.status,
                status_error: __payment.status_error,
                due_business_date: _due_business_date,
              });

              const _payment_for =
                __payment.customPayments?.payer_type === "produto"
                  ? "Produto"
                  : __payment.customPayments?.payer_type === "formando"
                    ? "Cobrança"
                    : __payment.customPayments?.payer_type === "distrato"
                      ? "Distrato"
                      : !__payment?.custom_payment_id
                        ? "Contratado"
                        : "Erro";

              return {
                id: __payment.id,
                aporte: __payment.aporte,
                aditional_information: __payment.aditional_information,
                bar_code: __payment.bar_code,
                boleto_url: __payment.boleto_url,
                cancel_date: __payment.cancel_date,
                commercial: __payment.commercial,
                cost_center: __payment.costCenter,
                expense: __payment.expense,
                expense_plan: __payment.expensePlan,
                custom_payment_id: __payment.custom_payment_id,
                custom_payment: __payment.customPayments,
                date_transpasse: __payment.date_transpasse,
                description: __payment.description,
                due_date: _due_date,
                due_business_date: _due_business_date,
                emission: stringToDate(__payment.emission),
                entry: __payment.entry,
                label: __payment.label,
                legacy_id: __payment.legacy_id || __payment.reboleto,
                is_legacy_reboleto: !!__payment.reboleto,
                logs: __payment.logBoletos,
                payment_method: __payment.method_payment,
                payment_date: __payment.payment_date,
                reboleto_parent_id: __payment.payment_slip_id,
                is_reboleto: __payment.reboleto,
                provider_id: __payment.provider_id,
                user_id: __payment.user_id,
                quota: __payment.quotas,
                quotas_total: __payment.total_quotas,
                status: _status,
                tax: __payment.tax,
                tax_description: __payment.tax_description,
                discount_type: __payment.type_discount,
                discount: __payment.value_discount,
                discount_description: __payment.discount_description,
                trainee: __payment.trainee,
                payment_type: __payment.type_payment,
                value_raw: __payment.value_raw,
                value: __payment.value,
                value_juros:
                  __payment.status === "cancelado" || __payment.status === "pago"
                    ? __payment.juros_real_time
                    : _calculated_juros || 0,
                value_paid: __payment.value_paid,
                payment_for: _payment_for,
              };
            }),
          });
        } catch (__err) {
          console.log("__err", __err);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx, outside this file's scope); adding it would refire this fetch on unrelated context updates. Real triggers (reload/load/query/is_trainee) are listed explicitly.
  }, [reload, load, query, is_trainee]);

  const reloadPage = () => {
    setreload(!reload);
  };
  const loadPage = () => {
    setload(true);
  };

  return {
    data: paymentSlips,
    reload: reloadPage,
    load: loadPage,
    setquery,
  };
};

export default usePaymentSlip;
